export { ThemeSwitcherComponent } from './theme-switcher/theme-switcher.component';
export { ThemeSwitcherMiniComponent } from './theme-switcher-mini/theme-switcher-mini.component';
